import { API_ROOT_REFDATA, API_ROOT_SEARCH, API_ROOT_SVR, API_ROOT_ORGS } from "../config";
import { ConfidencesService } from "./business/ConfidencesService";
import { IntelligenceSourcesService } from "./business/IntelligenceSourcesService";
import { RiskTypesService } from "./business/RiskTypesService";
import { SystemicSourcesService } from "./business/SystemicSourcesService";
import { TagsService } from "./business/TagsService";
import { ValencesService } from "./business/ValencesService";
import { AwardingOrgSearchService } from "./business/AwardingOrgSearchService";
import { AwardingOrgService } from "./business/AwardingOrgService";

import { SvrService } from "./business/SvrService";
import { cachingService } from "@ofqual/portal-core/core/dataAccess";

export const intelligenceSourcesService = new IntelligenceSourcesService(
  API_ROOT_REFDATA
);
export const valencesService = new ValencesService(API_ROOT_REFDATA);
export const riskTypesService = new RiskTypesService(API_ROOT_REFDATA);
export const confidencesService = new ConfidencesService(API_ROOT_REFDATA);
export const systemicSourcesService = new SystemicSourcesService(
  API_ROOT_REFDATA
);

export const cachingSystemSourcesService = cachingService(
  systemicSourcesService
);

export const tagsService = new TagsService(API_ROOT_REFDATA);

export const aoServiceSearch = new AwardingOrgSearchService(API_ROOT_SEARCH);
export const aoService = new AwardingOrgService(API_ROOT_ORGS);
export const submissionService = new SvrService(API_ROOT_SVR);
